/**
 * 加载动画组件
 */
class LoadingAnimation extends HTMLElement {
  constructor() {
    super();
  }
  
  show() {
    this.classList.remove('uk-hidden');
  }
  
  hide() {
    this.classList.add('uk-hidden');
  }
}

customElements.define('loading-animation', LoadingAnimation);
